import { render, staticRenderFns } from "./warn_article.vue?vue&type=template&id=3d723386&scoped=true"
import script from "./warn_article.vue?vue&type=script&lang=ts"
export * from "./warn_article.vue?vue&type=script&lang=ts"
import style0 from "./warn_article.vue?vue&type=style&index=0&id=3d723386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d723386",
  null
  
)

export default component.exports